// eslint-disable-next-line no-restricted-imports
import {
  Query_LegalClientController_GetList_AllOf_1_List_Items_OrganizationalAndLegalForm_OrganizationType as OrganizationTypeApi,
  OrganizationalAndLegalFormDto_Input,
} from 'api/generated/graphql';
import { OrganizationType } from 'api/types/entity';
import { OrganizationalAndLegalFormParam } from 'api/types/params';

const organizationTypeMap: Record<OrganizationType, OrganizationTypeApi> = {
  [OrganizationType.Commercial]: OrganizationTypeApi.Commercial,
  [OrganizationType.NonCommercial]: OrganizationTypeApi.NonCommercial,
};

export const parseOrganizationalAndLegalFormParam = (
  params: OrganizationalAndLegalFormParam
): OrganizationalAndLegalFormDto_Input => ({
  isFinancialInstitution: params.isFinancialInstitution,
  isUnincorporatedStructure: params.isUnincorporatedStructure,
  organizationalAndLegalForm: params.organizationalAndLegalForm,
  organizationType: params.organizationType
    ? organizationTypeMap[params.organizationType]
    : undefined,
});
